(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6123],{

/***/ 9294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BlogTag; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var BlogTag = function BlogTag(_ref) {
  var name = _ref.name,
      tagColor = _ref.tagColor;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
    color: tagColor,
    children: ["#", name]
  });
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "BlogTag__Tag",
  componentId: "sc-1yvutcw-0"
})(["font-size:16px;line-height:27px;letter-spacing:0;color:#ffffff;background-color:", ";padding:0 18px 0 16px;border-radius:14px;@media screen and (max-width:1047px){font-size:13px;line-height:23px;}"], function (_ref2) {
  var color = _ref2.color;
  return color;
});

/***/ }),

/***/ 1300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Interviewee; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Interviewee = function Interviewee(_ref) {
  var profileImage = _ref.profileImage,
      fullName = _ref.fullName,
      biography = _ref.biography;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
      src: profileImage.src,
      width: "44px",
      height: "44px",
      alt: fullName
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorName, {
        children: fullName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorPosition, {
        children: biography
      })]
    })]
  });
};
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__Content",
  componentId: "sc-13t4m1r-0"
})(["display:flex;align-items:center;gap:13px;"]);
var Image = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "Interviewee__Image",
  componentId: "sc-13t4m1r-1"
})(["border-radius:50%;"]);
var EditorName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorName",
  componentId: "sc-13t4m1r-2"
})(["font-size:15px;line-height:17px;letter-spacing:1.5px;color:", ";margin-bottom:2px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var EditorPosition = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorPosition",
  componentId: "sc-13t4m1r-3"
})(["font-size:11px;line-height:15px;letter-spacing:1.1px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 34481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ HTMLParser; }
/* harmony export */ });
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25935);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_elements_Icon_ExternalLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var isExternalLink = function isExternalLink(domNode) {
  if (domNode.name !== 'a') {
    return false;
  }

  if (domNode.attribs.href.startsWith('https://trial-holdings.inc')) {
    return false;
  }

  return true;
};

var HTMLParser = function HTMLParser(_ref) {
  var text = _ref.text;

  var parser = function parser(input) {
    return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(input, {
      replace: function replace(domNode) {
        if (domNode instanceof html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* .Element */ .W_) {
          var _domNode$firstChild;

          if (domNode.attribs["class"] === 'remove') {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
          }

          if (isExternalLink(domNode) && ((_domNode$firstChild = domNode.firstChild) === null || _domNode$firstChild === void 0 ? void 0 : _domNode$firstChild.type) === 'text') {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
              href: domNode.attribs.href,
              rel: "noopener noreferrer",
              target: "_blank",
              children: [domNode.firstChild.data, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Icon_ExternalLink__WEBPACK_IMPORTED_MODULE_2__/* .ExternalLinkIcon */ .h, {
                size: "small"
              })]
            });
          }
        }
      }
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: parser((0,isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__.sanitize)(text))
  });
};

/***/ }),

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 7257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMediaQuery = function useMediaQuery(mediaQuery) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMatch = _useState[0],
      setIsMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = function documentChangeHandler() {
      setIsMatch(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', documentChangeHandler);
    documentChangeHandler();
    return function () {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [mediaQuery]);
  return isMatch;
};

/***/ }),

/***/ 82256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ BlogArticlePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/components/elements/Blog/BlogTag/index.tsx
var BlogTag = __webpack_require__(9294);
// EXTERNAL MODULE: ./src/components/elements/Blog/Interviewee/index.tsx
var Interviewee = __webpack_require__(1300);
// EXTERNAL MODULE: ./src/components/elements/HTMLParser/index.tsx
var HTMLParser = __webpack_require__(34481);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(7257);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/BlogId/BlogArticle.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var BlogArticle = function BlogArticle(_ref) {
  var title = _ref.title,
      coverImage = _ref.coverImage,
      tag = _ref.tag,
      interviewee = _ref.interviewee,
      body = _ref.body,
      publishDate = _ref.publishDate;
  var isMobile = (0,useMediaQuery/* useMediaQuery */.a)('(max-width: 1047px)');
  var cover = isMobile ? coverImage.spCoverImage : coverImage.pcCoverImage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Article, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CoverImage, {
        alt: cover.altText,
        src: cover.src
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 40,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MetaInfo, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlogArticle_Date, {
          dateTime: publishDate,
          children: (0,date/* formatDate */.p6)(publishDate, 'yyyy.MM.dd')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 12,
            pc: 22
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
          children: tag.map(function (item) {
            return /*#__PURE__*/(0,react.createElement)(BlogTag/* BlogTag */.F, _objectSpread(_objectSpread({}, item), {}, {
              key: item._id
            }));
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 22,
            pc: 28
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 26,
            pc: 40
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Interviewee/* Interviewee */.d, _objectSpread({}, interviewee)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 46,
            pc: 64
          }
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HTMLParser/* HTMLParser */.J, {
        text: body
      })
    })]
  });
};
var Article = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "BlogArticle__Article",
  componentId: "sc-gdn5wd-0"
})(["width:1040px;margin:74px auto 130px;@media screen and (max-width:1047px){width:100%;margin:39px 0 80px;}"]);
var CoverImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "BlogArticle__CoverImage",
  componentId: "sc-gdn5wd-1"
})(["width:1040px;height:360px;border-radius:12px;object-fit:cover;@media screen and (max-width:1047px){width:100%;height:135px;border-radius:0;}"]);
var BlogArticle_Date = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "BlogArticle__Date",
  componentId: "sc-gdn5wd-2"
})(["font-size:16px;letter-spacing:1.6px;line-height:25px;color:", ";@media screen and (max-width:1047px){font-size:14px;letter-spacing:1.4px;}"], theme/* theme.colors.textSecond */.r.colors.textSecond);
var MetaInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BlogArticle__MetaInfo",
  componentId: "sc-gdn5wd-3"
})(["@media screen and (max-width:1047px){padding:0 20px;}"]);
var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BlogArticle__Tag",
  componentId: "sc-gdn5wd-4"
})(["display:flex;gap:10px;"]);
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "BlogArticle__Title",
  componentId: "sc-gdn5wd-5"
})(["font-size:28px;letter-spacing:2.8px;line-height:40px;font-weight:bold;color:", ";@media screen and (max-width:1047px){font-size:22px;letter-spacing:2.2px;line-height:28px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "BlogArticle__Section",
  componentId: "sc-gdn5wd-6"
})(["position:relative;p{font-size:18px;letter-spacing:0.36px;line-height:40px;color:", ";margin-bottom:20px;}a{color:", ";&:hover{text-decoration:underline;}> svg{margin-left:8px;fill:", ";}}strong{font-weight:bold;}em{font-style:italic;}img{max-width:100%;}h2{font-size:24px;font-weight:bold;letter-spacing:1.44px;line-height:36px;color:", ";margin-top:40px;margin-bottom:20px;margin-left:12px;&:before{content:'';height:29px;width:4px;background-color:", ";position:absolute;left:0;margin-top:6px;}}h3{font-size:22px;font-weight:bold;letter-spacing:1.32px;line-height:36px;color:", ";margin-top:40px;margin-bottom:20px;margin-left:12px;&:before{content:'';height:29px;width:4px;background-color:", ";position:absolute;left:0;margin-top:5px;}}@media screen and (max-width:1047px){padding:0 20px;p{font-size:16px;letter-spacing:0.32px;line-height:30px;}a{text-decoration:underline;}h2{font-size:22px;letter-spacing:0.44px;line-height:28px;margin-top:19px;margin-bottom:18px;margin-left:15px;&:before{height:32px;margin:0;left:20px;}}h3{font-size:20px;letter-spacing:0.4px;line-height:28px;margin-top:18px;margin-bottom:18px;margin-left:15px;&:before{height:32px;margin-top:-3px;left:20px;}}}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.hover */.r.colors.hover, theme/* theme.colors.hover */.r.colors.hover, theme/* theme.colors.hover */.r.colors.hover, theme/* theme.colors.hover */.r.colors.hover, theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.hover */.r.colors.hover);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/BlogId/index.tsx


function BlogId_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function BlogId_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BlogId_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BlogId_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var BlogArticlePage = function BlogArticlePage(_ref) {
  var blog = _ref.blog;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogArticle, BlogId_objectSpread({}, blog));
};

BlogArticlePage.getLayout = function getLayout(page) {
  var _meta$blogUtilMeta, _meta$blogUtilMeta2;

  var pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム'
  };
  var _page$props$blog = page.props.blog,
      _id = _page$props$blog._id,
      title = _page$props$blog.title,
      individualMeta = _page$props$blog.individualMeta,
      utilMeta = _page$props$blog.utilMeta;
  var meta = individualMeta !== null && individualMeta !== void 0 ? individualMeta : utilMeta;
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news/'
  }, {
    name: '広報ブログ',
    path: '/news/blog'
  }, {
    name: title,
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: title,
      description: (meta === null || meta === void 0 ? void 0 : (_meta$blogUtilMeta = meta.blogUtilMeta) === null || _meta$blogUtilMeta === void 0 ? void 0 : _meta$blogUtilMeta.description) || '',
      ogp: {
        type: 'article',
        title: meta === null || meta === void 0 ? void 0 : meta.title,
        url: "news/blog/".concat(_id),
        image: meta === null || meta === void 0 ? void 0 : (_meta$blogUtilMeta2 = meta.blogUtilMeta) === null || _meta$blogUtilMeta2 === void 0 ? void 0 : _meta$blogUtilMeta2.ogImage
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, BlogId_objectSpread(BlogId_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      children: page
    }))]
  });
};
;// CONCATENATED MODULE: ./src/pages/news/blog/[blogId].tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 77990:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/blog/[blogId]",
      function () {
        return __webpack_require__(82256);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,2167,342,5548,9774,2888,179], function() { return __webpack_exec__(77990); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);